const Popup = {
  popup: document.querySelector('[data-popup]'),
  popup_close: document.querySelectorAll('[data-popup-close]'),

  init: function () {
    // verify elements
    if (this.popup && this.popup_close) {

      // verify local storage
      if (!localStorage.getItem('popup-closed')) {
  
        // show popup
        const show = () => { 
          if (!this.popup.classList.contains('-active')) this.popup.classList.add('-active');
          window.removeEventListener('mousemove', show);
          window.removeEventListener('scroll', show);
        }
        window.addEventListener('mousemove', show);
        window.addEventListener('scroll', show);
  
        // handle close
        if (this.popup_close.length > 0) this.popup_close.forEach(close => {
          close.addEventListener('click', () => { 
            
            // hide popup
            this.popup.classList.remove('-active');
  
            // set local storage
            localStorage.setItem('popup-closed', true);

          });
        });
      }
    }
  }
}

export default Popup;
